import {useQuery} from '@tanstack/react-query';
import {OhdService} from '../services/ohdService';

export function useOhdOrganizations(enabled = true) {
    return useQuery({
        queryKey: ['ohd-organizations'],
        queryFn: () => OhdService.listOrganizations(),
        enabled,
        staleTime: 5 * 60 * 1000,
    });
}
